export default {
  title: 'Dados bancários',
  sections: {
    personal_info: 'Dados pessoais',
    address: 'Morada',
  },
  labels: {
    account_number: 'Número de conta',
    routing_number: 'Número de roteamento',
    email: 'Email',
    full_name: 'Nome completo',
    street: 'Rua',
    zip_code: 'Código postal',
    city: 'Cidade',
  },
  tooltip: '{{field}} copiado para a área de transferência!',
};
